import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { Breadcrumb, Button, Confirm, Container, Loader } from "semantic-ui-react"
import styled from "styled-components"
import { ContextFormModal, ContextsTable } from "./components"
import { CaseStatusesApiService, UnitsApiService } from "./../../api"

const Contexts = ({
	availableFields,
	contexts,
	isDeleteConfirmOpen,
	isLoading,
	isModalOpen,
	onCloseFormModal,
	onCreateContext,
	onDeleteCancel,
	onDeleteConfirm,
	onDeleteContext,
	onEditContext,
	onSaveContext,
	selectedContext
}) => (
	<Container>
		<Breadcrumb>
			<Breadcrumb.Section as={Link} to="/">
				Strona główna
			</Breadcrumb.Section>
			<Breadcrumb.Divider icon="right angle" />
			<Breadcrumb.Section active>Konteksty</Breadcrumb.Section>
		</Breadcrumb>
		<ButtonContainer>
			<Button
				content="Dodaj kontekst"
				icon="add"
				labelPosition="left"
				onClick={onCreateContext}
				positive
			/>
		</ButtonContainer>
		{isLoading ? (
			<Loader active={true} content="Ładowanie kontekstów..." inline="centered" />
		) : (
			<ContextsTable
				availableFields={availableFields}
				contexts={contexts}
				onDeleteContext={onDeleteContext}
				onEditContext={onEditContext}
			/>
		)}
		<Confirm
			cancelButton="Anuluj"
			confirmButton="Potwierdź"
			content="Czy na pewno usunąć kontekst?"
			onCancel={onDeleteCancel}
			onConfirm={onDeleteConfirm}
			open={isDeleteConfirmOpen}
		/>
		<ContextFormModal
			availableFields={availableFields}
			context={selectedContext}
			onClose={onCloseFormModal}
			onSave={onSaveContext}
			open={isModalOpen}
		/>
	</Container>
)

Contexts.propTypes = {
	contexts: PropTypes.array,
	isDeleteConfirmOpen: PropTypes.bool,
	isModalOpen: PropTypes.bool,
	onCloseFormModal: PropTypes.func.isRequired,
	onCreateContext: PropTypes.func.isRequired,
	onDeleteCancel: PropTypes.func.isRequired,
	onDeleteConfirm: PropTypes.func.isRequired,
	onDeleteContext: PropTypes.func.isRequired,
	onEditContext: PropTypes.func.isRequired,
	onSaveContext: PropTypes.func.isRequired,
	selectedContext: PropTypes.object
}

Contexts.defaultProps = {
	contexts: [],
	selectedContext: null
}

const ButtonContainer = styled.div`
	margin-top: 14px;
`

const enhance = compose(
	withState("availableFields", "setAvailableFields", []),
	withState("contexts", "setContexts", []),
	withState("isLoading", "setLoading", false),
	withState("isDeleteConfirmOpen", "setDeleteConfirmOpen", false),
	withState("isModalOpen", "setModalOpen", false),
	withState("selectedContext", "setSelectedContext", null),
	withHandlers({
		onCloseFormModal: ({ setModalOpen, setSelectedContext }) => () => {
			setModalOpen(false)
			setSelectedContext(null)
		},
		onCreateContext: ({ setModalOpen }) => () => {
			setModalOpen(true)
		},
		onDeleteCancel: ({ setDeleteConfirmOpen, setSelectedContext }) => () => {
			setDeleteConfirmOpen(false)
			setSelectedContext(null)
		},
		onDeleteConfirm: ({
			contexts,
			selectedContext,
			setContexts,
			setDeleteConfirmOpen,
			setSelectedContext
		}) => async () => {
			const { id: selectedContextId } = selectedContext
			await UnitsApiService.deleteUnit(selectedContextId)
			const newContexts = contexts.filter(context => context.id !== selectedContextId)
			setContexts(newContexts)
			setDeleteConfirmOpen(false)
			setSelectedContext(null)
		},
		onDeleteContext: ({ setDeleteConfirmOpen, setSelectedContext }) => context => {
			setDeleteConfirmOpen(true)
			setSelectedContext(context)
		},
		onEditContext: ({ setModalOpen, setSelectedContext }) => context => {
			setModalOpen(true)
			setSelectedContext(context)
		},
		onSaveContext: ({ contexts, selectedContext, setContexts }) => async newContext => {
			const newContexts = selectedContext
				? contexts.map(
						context =>
							context.id === selectedContext.id
								? { ...context, ...newContext }
								: context
				  )
				: [...contexts, newContext]
			setContexts(newContexts)
		}
	}),
	lifecycle({
		async componentDidMount() {
			const availableFields = await CaseStatusesApiService.getAvailableFields()
			this.props.setAvailableFields(availableFields)
			this.props.setLoading(true)
			try {
				const contexts = await UnitsApiService.getUnits()
				this.props.setContexts(contexts)
			} finally {
				this.props.setLoading(false)
			}
		}
	})
)

export { Contexts, enhance }
export default enhance(Contexts)



// WEBPACK FOOTER //
// ./src/containers/contexts/Contexts.js